import { z } from 'zod';
import type {
  ListInboundReceiptDraftsRequest,
  ListInboundReceiptDraftsResponse,
} from './list-inbound-receipt-drafts.dto.js';
import { InboundReceiptDraftSchema } from './inbound-receipts-shared.schema.js';

export const ListInboundReceiptDraftsRequestSchema: z.ZodType<ListInboundReceiptDraftsRequest> =
  z
    .object({
      companyId: z.uuid(),
      stationId: z.uuid(),
    })
    .strict();

export const ListInboundReceiptDraftsResponseSchema: z.ZodType<ListInboundReceiptDraftsResponse> =
  z
    .object({
      items: z.array(InboundReceiptDraftSchema),
    })
    .strict();
